export const STEPS = [
  {
    name: "รายละเอียด",
    value: 1
  },
  {
    name: "เลือกเเผน",
    value: 2
  },
  {
    name: "กรอกข้อมูล",
    value: 3
  },
  {
    name: "ชำระเงิน",
    value: 4
  }
];

export const PURPOSE_OF_TOURISM = [
  {
    value: "ท่องเที่ยว",
    label: "ท่องเที่ยว"
  },
  {
    value: "ธุรกิจ",
    label: "ธุรกิจ"
  },
  { value: "อื่นๆ", label: "อื่นๆ" }
];

export const TYPE_DETAILS = [
  {
    usertype: 1,
    details: "แผนรายเดี่ยวกำหนดอายุตั้งแต่ 1-80 ปี"
  },
  {
    usertype: 2,
    details:
      "แผนครอบครัว สำหรับผู้เอาประกันภัยเดินทางพร้อมกัน 2 - 4 ท่าน โดยไม่จำเป็นต้องลักษณะพ่อแม่ลูกกัน โดยมีกำหนดต้องมีผู้ใหญ่ 1 ท่าน (อายุ 21 ปีขึ้นไป) และเด็ก 1 ท่าน (อายุ 1 – 20 ปี) อยู่ในการเดินทางพร้อมกัน"
  }
];

export const DESTINATION_COUNTRY = [
  { value: "WORLDWIDE", label: "WORLDWIDE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "Shcengen Group Countries", label: "Shcengen Group Countries", zone: "WORLDWIDE", group:"SCHENGEN" },
  { value: "ASIA", label: "ASIA", zone: "ASIA", group:"ASIA" },
  { value: "ANDORRA", label: "ANDORRA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "UNITED ARAB EMIRATES", label: "UNITED ARAB EMIRATES", zone: "ASIA", group:"ASIA"},
  { value: "ANTIGUA AND BARBUDA", label: "ANTIGUA AND BARBUDA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "ALBANIA", label: "ALBANIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "ARMENIA", label: "ARMENIA", zone: "ASIA", group:"ASIA"},
  { value: "ARGENTINA", label: "ARGENTINA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "AUSTRIA", label: "AUSTRIA", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "AUSTRALIA", label: "AUSTRALIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BOSNIA AND HERZEGOVINA", label: "BOSNIA AND HERZEGOVINA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BARBADOS", label: "BARBADOS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BANGLADESH", label: "BANGLADESH", zone: "ASIA", group:"ASIA"},
  { value: "BELGIUM", label: "BELGIUM", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "BURKINA FASO", label: "BURKINA FASO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BULGARIA", label: "BULGARIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BAHRAIN", label: "BAHRAIN", zone: "ASIA", group:"ASIA"},
  { value: "BENIN", label: "BENIN", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BRUNEI DARUSSALAM", label: "BRUNEI DARUSSALAM", zone: "ASIA", group:"ASIA"},
  { value: "BOLIVIA", label: "BOLIVIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BRAZIL", label: "BRAZIL", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BAHAMAS", label: "BAHAMAS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BHUTAN", label: "BHUTAN", zone: "ASIA", group:"ASIA"},
  { value: "BOTSWANA", label: "BOTSWANA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BELARUS", label: "BELARUS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "BELIZE", label: "BELIZE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CANADA", label: "CANADA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "THE DEMOCRATIC REPUBLIC OF THE CONGO", label: "THE DEMOCRATIC REPUBLIC OF THE CONGO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CENTRAL AFRICAN REPUBLIC", label: "CENTRAL AFRICAN REPUBLIC", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "REPUBLIC OF THE CONGO", label: "REPUBLIC OF THE CONGO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SWITZERLAND", label: "SWITZERLAND", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "COTE D'IVOIRE", label: "COTE D'IVOIRE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CHILE", label: "CHILE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CAMEROON", label: "CAMEROON", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CHINA", label: "CHINA", zone: "ASIA", group:"ASIA"},
  { value: "COLOMBIA", label: "COLOMBIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "COSTA RICA", label: "COSTA RICA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SCOTLAND", label: "SCOTLAND", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CAPE VERDE", label: "CAPE VERDE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CYPRUS", label: "CYPRUS", zone: "ASIA", group:"ASIA"},
  { value: "CZECH REPUBLIC", label: "CZECH REPUBLIC", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "GERMANY", label: "GERMANY", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "DJIBOUTI", label: "DJIBOUTI", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "DENMARK", label: "DENMARK", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "DOMINICA", label: "DOMINICA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "DOMINICAN REPUBLIC", label: "DOMINICAN REPUBLIC", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "ECUADOR", label: "ECUADOR", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "ESTONIA", label: "ESTONIA", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "EGYPT", label: "EGYPT", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SPAIN", label: "SPAIN", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "FINLAND", label: "FINLAND", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "FIJI", label: "FIJI", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MICRONESIA (FEDERATED STATES OF)", label: "MICRONESIA (FEDERATED STATES OF)", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "FRANCE", label: "FRANCE", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "GABON", label: "GABON", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "UNITED KINGDOM", label: "UNITED KINGDOM", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GRENADA", label: "GRENADA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GEORGIA", label: "GEORGIA", zone: "ASIA", group:"ASIA"},
  { value: "FRENCH GUIANA", label: "FRENCH GUIANA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GAMBIA", label: "GAMBIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GUINEA", label: "GUINEA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "EQUATORIAL GUINEA", label: "EQUATORIAL GUINEA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GREECE", label: "GREECE", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "GUATEMALA", label: "GUATEMALA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GUINEA-BISSAU", label: "GUINEA-BISSAU", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "GUYANA", label: "GUYANA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "HONG KONG", label: "HONG KONG", zone: "ASIA", group:"ASIA"},
  { value: "HONDURAS", label: "HONDURAS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CROATIA", label: "CROATIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "HUNGARY", label: "HUNGARY", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "INDONESIA", label: "INDONESIA", zone: "ASIA", group:"ASIA"},
  { value: "IRELAND", label: "IRELAND", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "INDIA", label: "INDIA", zone: "ASIA", group:"ASIA"},
  { value: "ICELAND", label: "ICELAND", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "ITALY", label: "ITALY", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "JAMAICA", label: "JAMAICA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "JORDAN", label: "JORDAN", zone: "ASIA", group:"ASIA"},
  { value: "JAPAN", label: "JAPAN", zone: "ASIA", group:"ASIA"},
  { value: "KENYA", label: "KENYA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "KYRGYZSTAN", label: "KYRGYZSTAN", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "Kurdistan", label: "Kurdistan", zone: "ASIA", group:"ASIA"},
  { value: "CAMBODIA", label: "CAMBODIA", zone: "ASIA", group:"ASIA"},
  { value: "KIRIBATI", label: "KIRIBATI", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "COMOROS", label: "COMOROS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SAINT KITTS AND NEVIS", label: "SAINT KITTS AND NEVIS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SOUTH KOREA", label: "SOUTH KOREA", zone: "ASIA", group:"ASIA"},
  { value: "KUWAIT", label: "KUWAIT", zone: "ASIA", group:"ASIA"},
  { value: "KAZAKHSTAN", label: "KAZAKHSTAN", zone: "ASIA", group:"ASIA"},
  { value: "LAO", label: "LAO", zone: "ASIA", group:"ASIA"},
  { value: "SAINT LUCIA", label: "SAINT LUCIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "LIECHTENSTEIN", label: "LIECHTENSTEIN", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SRI LANKA", label: "SRI LANKA", zone: "ASIA", group:"ASIA"},
  { value: "LESOTHO", label: "LESOTHO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "LITHUANIA", label: "LITHUANIA", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "LUXEMBOURG", label: "LUXEMBOURG", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "LATVIA", label: "LATVIA", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "MOROCCO", label: "MOROCCO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MONACO", label: "MONACO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MOLDOVA REPUBLIC OF", label: "MOLDOVA REPUBLIC OF", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MONTENEGRO REPUBLIC OF", label: "MONTENEGRO REPUBLIC OF", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MADAGASCAR", label: "MADAGASCAR", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MARSHALL ISLANDS", label: "MARSHALL ISLANDS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MACEDONIA", label: "MACEDONIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MALI", label: "MALI", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MYANMAR", label: "MYANMAR", zone: "ASIA", group:"ASIA"},
  { value: "MONGOLIA", label: "MONGOLIA", zone: "ASIA", group:"ASIA"},
  { value: "MACAO", label: "MACAO", zone: "ASIA", group:"ASIA"},
  { value: "NORTHERN MARIANA ISLANDS", label: "NORTHERN MARIANA ISLANDS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MAURITANIA", label: "MAURITANIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MALTA", label: "MALTA", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "MAURITIUS", label: "MAURITIUS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MALDIVES", label: "MALDIVES", zone: "ASIA", group:"ASIA"},
  { value: "MALAWI", label: "MALAWI", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MEXICO", label: "MEXICO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "MALAYSIA", label: "MALAYSIA", zone: "ASIA", group:"ASIA"},
  { value: "MOZAMBIQUE", label: "MOZAMBIQUE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NAMIBIA", label: "NAMIBIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NEW CALEDONIA", label: "NEW CALEDONIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NIGER", label: "NIGER", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NIGERIA", label: "NIGERIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NICARAGUA", label: "NICARAGUA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NETHERLANDS", label: "NETHERLANDS", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "NORWAY", label: "NORWAY", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "NEPAL", label: "NEPAL", zone: "ASIA", group:"ASIA"},
  { value: "NAURU", label: "NAURU", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "NEW ZEALAND", label: "NEW ZEALAND", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "OMAN", label: "OMAN", zone: "ASIA", group:"ASIA"},
  { value: "PANAMA", label: "PANAMA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "PERU", label: "PERU", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "PAPUA NEW GUINEA", label: "PAPUA NEW GUINEA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "PHILIPPINES", label: "PHILIPPINES", zone: "ASIA", group:"ASIA"},
  { value: "POLAND", label: "POLAND", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "PUERTO RICO", label: "PUERTO RICO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "PORTUGAL", label: "PORTUGAL", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "PARAGUAY", label: "PARAGUAY", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "QATAR", label: "QATAR", zone: "ASIA", group:"ASIA"},
  { value: "ROMANIA", label: "ROMANIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SERBIA", label: "SERBIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "RUSSIAN FEDERATION", label: "RUSSIAN FEDERATION", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SAUDI ARABIA", label: "SAUDI ARABIA", zone: "ASIA", group:"ASIA"},
  { value: "SOLOMON ISLANDS", label: "SOLOMON ISLANDS", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SEYCHELLES", label: "SEYCHELLES", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SWEDEN", label: "SWEDEN", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "SINGAPORE", label: "SINGAPORE", zone: "ASIA", group:"ASIA"},
  { value: "SLOVENIA", label: "SLOVENIA", zone: "WORLDWIDE", group:"SCHENGEN"},
  { value: "SLOVAKIA (SLOVAK REPUBLIC)", label: "SLOVAKIA (SLOVAK REPUBLIC)", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SIERRA LEONE", label: "SIERRA LEONE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SAN MARINO", label: "SAN MARINO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SENEGAL", label: "SENEGAL", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SOMALIA", label: "SOMALIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SURINAME", label: "SURINAME", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SAO TOME AND PRINCIPE", label: "SAO TOME AND PRINCIPE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "EL SALVADOR", label: "EL SALVADOR", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SWAZILAND", label: "SWAZILAND", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "CHAD", label: "CHAD", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "TOGO", label: "TOGO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "TAJIKISTAN", label: "TAJIKISTAN", zone: "ASIA", group:"ASIA"},
  { value: "TIMOR-LESTE", label: "TIMOR-LESTE", zone: "ASIA", group:"ASIA"},
  { value: "TURKMENISTAN", label: "TURKMENISTAN", zone: "ASIA", group:"ASIA"},
  { value: "TUNISIA", label: "TUNISIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "TONGA", label: "TONGA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "TURKEY", label: "TURKEY", zone: "ASIA", group:"ASIA"},
  { value: "TRINIDAD AND TOBAGO", label: "TRINIDAD AND TOBAGO", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "TUVALU", label: "TUVALU", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "TAIWAN", label: "TAIWAN", zone: "ASIA", group:"ASIA"},
  { value: "TANZANIA UNITED REPUBLIC OF", label: "TANZANIA UNITED REPUBLIC OF", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "UKRAINE", label: "UKRAINE", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "UGANDA", label: "UGANDA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "UNITED STATES", label: "UNITED STATES", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "URUGUAY", label: "URUGUAY", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "HOLY SEE (VATICAN CITY STATE)", label: "HOLY SEE (VATICAN CITY STATE)", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SAINT VINCENT AND THE GRENADINES", label: "SAINT VINCENT AND THE GRENADINES", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "VENEZUELA", label: "VENEZUELA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "VIETNAM", label: "VIETNAM", zone: "ASIA", group:"ASIA"},
  { value: "VANUATU", label: "VANUATU", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SAMOA", label: "SAMOA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "YEMEN", label: "YEMEN", zone: "ASIA", group:"ASIA"},
  { value: "YUGOSLAVIA", label: "YUGOSLAVIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "SOUTH AFRICA", label: "SOUTH AFRICA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "ZAMBIA", label: "ZAMBIA", zone: "WORLDWIDE", group:"WORLDWIDE"},
  { value: "ZIMBABWE", label: "ZIMBABWE", zone: "WORLDWIDE", group:"WORLDWIDE"}
];
